import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, track } from '@/lib/analytics';

/**
 * Starts the analytics session and records a page view on every route change.
 *
 * Renders nothing; it exists so route tracking lives inside the Router (where
 * `useLocation` works) without every page having to remember to instrument
 * itself. Page-specific events (viewing an event, searching, adding to cart)
 * are emitted from the pages that own those actions.
 */
export default function AnalyticsTracker() {
  const location = useLocation();
  const started = useRef(false);
  const skippedFirst = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    initAnalytics();
  }, []);

  useEffect(() => {
    // `initAnalytics` already recorded app_open for the landing path, so the
    // first route change is skipped - both effects run on mount, and counting
    // the landing page twice would inflate every entry-page number.
    if (!skippedFirst.current) {
      skippedFirst.current = true;
      return;
    }
    track('page_view', {
      path: location.pathname,
      search: location.search || undefined,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return null;
}
